import SubscribeForm from "@/components/feature/SubscribeForm";

export default function SubscribeCta() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 items-center gap-10 rounded-lg border border-background-200 bg-background-100 p-6 md:p-10 lg:grid-cols-2">
        <div>
          <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.25em] text-primary-600">
            <i className="ri-notification-3-line text-base"></i>
            NEWSLETTER
          </span>
          <h2 className="mt-4 font-heading text-2xl font-black leading-tight text-foreground-950 md:text-3xl">
            订阅吃瓜日报，重要的事不落下
          </h2>
          <p className="mt-4 max-w-lg text-sm leading-7 text-foreground-600">
            每天上午 9 点，把前一天最值得关注的娱乐话题整理成一封简短的邮件。没有标题党，只有时间线和结论。
          </p>
          <ul className="mt-6 space-y-3">
            {["当日热榜前三速览", "深度专题抢先读", "娱乐日历与作品排期"].map((item) => (
              <li key={item} className="flex items-center gap-3 text-sm text-foreground-700">
                <i className="ri-checkbox-circle-fill text-lg text-accent-600"></i>
                {item}
              </li>
            ))}
          </ul>
        </div>
        <SubscribeForm />
      </div>
    </section>
  );
}